import { SaleTransactionType } from 'api-hooks/refund/refund';
import { NavigationRoutes } from 'common/constants';
import notification from 'components/common/notification';
import { Input } from 'components/elements';
import { Button } from 'components/elements/buttons';
import Text from 'components/elements/text';
import useNavigation from 'hooks/use-navigation';
import EmployeeSelectInput from 'legacy-modules/master/select-input/employee-select-input';
import {
  CardSection,
  FullContainer,
  HalfContainer,
  OneThirdContainer,
  SectionContainer,
  SeparatorVertical,
} from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { useFormContext } from 'react-hook-form';

export default function CustomerDetailField() {
  const { t } = useTranslation();
  const { navigate } = useNavigation();
  const { getValues } = useFormContext();

  const onItemInvoked = React.useCallback(() => {
    const id = getValues('sales.id');
    const transactionType = getValues('sales.transactionType');

    let target = '';

    switch (transactionType) {
      case SaleTransactionType.ACTIVITY:
        target = NavigationRoutes.ActivitySalesView;
        break;
      case SaleTransactionType.CRUISE:
        target = NavigationRoutes.CruiseSalesView;
        break;
      case SaleTransactionType.DOCUMENT:
        target = NavigationRoutes.TravelDocumentSalesView;
        break;
      case SaleTransactionType.FLIGHT:
        target = NavigationRoutes.TicketSalesView;
        break;
      case SaleTransactionType.HOTEL:
        target = NavigationRoutes.HotelSalesView;
        break;
      case SaleTransactionType.PRODUCT:
        target = NavigationRoutes.ProductSalesView;
        break;
      default:
        notification.error({
          message: t('refund:no_selected_extra', {
            extra: t('common:invoice_number'),
          }),
        });
        return <></>;
    }

    navigate(target as NavigationRoutes, {
      id,
    });
  }, [getValues, navigate, t]);

  return (
    <CardSection style={{ paddingBottom: 0 }}>
      <FullContainer>
        <SectionContainer $style={{ alignItem: 'center' }}>
          <div style={{ flex: 1 }}>
            <Text variant="HeadingXSmall">{t('common:sales_details')}</Text>
          </div>
          <SeparatorVertical $margin={8} />
          <Button onClick={onItemInvoked} buttonType="secondary">
            {t('common:view_detail')}
          </Button>
        </SectionContainer>
        <SeparatorVertical $margin={36} />

        <SectionContainer>
          <HalfContainer>
            <Input
              type="text"
              name="sales.code"
              label={t('common:group_code')}
              placeholder={t('common:group_code')}
              disabled
            />
          </HalfContainer>
          <HalfContainer>
            <Input
              type="text"
              name="sales.description"
              label={t('common:description')}
              placeholder={t('common:description')}
              disabled
            />
          </HalfContainer>
        </SectionContainer>
        <SectionContainer>
          <HalfContainer>
            <Input
              type="date-time"
              name="sales.transactionAt"
              label={t('common:transaction_at')}
              placeholder={t('common:transaction_at')}
              disabled
            />
          </HalfContainer>
          <HalfContainer>
            <Input
              type="number"
              name="sales.total"
              label={t('common:total')}
              placeholder={t('common:total')}
              disabled
            />
          </HalfContainer>
        </SectionContainer>
        <SectionContainer>
          <OneThirdContainer>
            <EmployeeSelectInput
              name="sales.adminId"
              label={t('common:admin')}
              disabled
            />
          </OneThirdContainer>
          <OneThirdContainer>
            <EmployeeSelectInput
              name="sales.operatorId"
              label={t('common:operator')}
              disabled
            />
          </OneThirdContainer>
          <OneThirdContainer>
            <EmployeeSelectInput
              name="sales.salesmanId"
              label={t('common:sales')}
              disabled
            />
          </OneThirdContainer>
        </SectionContainer>
      </FullContainer>
    </CardSection>
  );
}
